import { styled } from '@abyss/web/tools/styled';
import { V2ModalDialog } from '@abyss/web/ui/ModalDialog';

export const GeospatialModalContainer = styled(V2ModalDialog, {
  '.abyss-modal-base-header-container': {
    padding: '16px',
  },
  '.abyss-modal-base-body': {
    rowGap: '8px',
  },
});
